import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { COMPANY, PUNTI_VENDITA } from 'configs/AppConfig'
import PuntiVenditaService from "../../services/PuntiVenditaService";
import { errorMessage } from "../../utils/messages";
import {
    COMPANY_ERROR,
    COMPANY_LOADED,
    COMPANY_VALUE,
    PROVENIENZE_VALUE,
    PUNTI_VENDITA_ERROR,
    PUNTI_VENDITA_LOADED,
    PUNTI_VENDITA_VALUE
} from "../../constants/AuthConstant";

export const initialState = COMPANY

export const loadCompany = createAsyncThunk('carica-azienda', async (data, { rejectWithValue }) => {
    console.log("[loadCompany]");
    try {

        const response = data.binding_role_user_companies ? data.binding_role_user_companies : [];
        let companies = []
        for (let i = 0; i < response.length; i++) {
            let company = response[i].company
            companies.push({
                id: company.id,
                nome: company.name,
                documentId: company.documentId,
                description: company.description,
                image: company.image,
                piva: company.piva
            })
        }

        console.table(companies)
        localStorage.setItem(COMPANY_VALUE, companies ? JSON.stringify(companies) : [])
        return companies
    } catch (err) {
        console.log("err", err)
        let message = (
            <div>
                Qualcosa è andato storto nel recuperare le aziende. Riprovare!
                <br />
                Se il problema persiste, contattare l' assistenza.
            </div>
        );

        errorMessage(message)
        return rejectWithValue('ERRORE')
    }
})

export const companies = createSlice({
    name: 'companies', initialState, reducers: {

        showLoading: (state) => {
            state.loadingCompany = true
        },
    }, extraReducers: (builder) => {
        builder
            .addCase(loadCompany.pending, (state) => {
                state.loadingCompany = true
                state.loadedCompany = false
                state.errorCompany = false
            })
            .addCase(loadCompany.fulfilled, (state, action) => {
                state.loadingCompany = false
                state.loadedCompany = true
                state.companies = action.payload
                localStorage.setItem(COMPANY_LOADED, true)
                localStorage.setItem(COMPANY_ERROR, false)
                state.errorCompany = false
            })
            .addCase(loadCompany.rejected, (state, action) => {
                state.loadingCompany = false
                state.loadedCompany = true
                state.puntiVendita = []
                localStorage.setItem(COMPANY_LOADED, true)
                localStorage.setItem(COMPANY_ERROR, true)
                localStorage.removeItem(COMPANY_VALUE)
                state.errorCompany = true
            })
    }
})

export const {
    showLoading
} = companies.actions

export default companies.reducer;